import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { fdate, mxn } from "@/lib/format";
import { DOC_ACTA_ENTREGA } from "@/lib/arrendamiento";
import { FilasResumen, OtDialog, SubirPdfOt, useAccionOt } from "./OtShared";

const hoy = () => new Date().toISOString().slice(0, 10);

// Devolver: con el acta de entrega el residual queda «Cancelada por devolución» y el bien pasa a «Bienes devueltos».
export function DevolucionDialog({ open, onOpenChange, ot, creditoId, onDone }) {
  const [d, setD] = useState({});
  const { busy, ejecutar } = useAccionOt(creditoId, onDone);
  useEffect(() => { if (open) setD({ fecha_entrega: hoy(), recibido_por: "", estado_bien: "", doc: null }); }, [open]);
  const set = (k, v) => setD((x) => ({ ...x, [k]: v }));
  const b = ot.bien || {};
  const bien = [b.descripcion_bien, b.marca, b.modelo, b.anio].filter(Boolean).join(" ");
  const body = { documento_id: d.doc?.id, fecha_entrega: d.fecha_entrega, recibido_por: d.recibido_por, estado_bien: d.estado_bien };
  return (
    <OtDialog open={open} onOpenChange={onOpenChange} testid="ot-devolucion-dialog" titulo="Devolver el bien"
      descripcion="El arrendatario entrega el bien a la arrendadora con el acta de entrega-recepción firmada."
      puedeRevisar={!!(d.doc && d.fecha_entrega && d.recibido_por?.trim())} busy={busy} textoConfirmar="Registrar devolución"
      onConfirmar={async () => { if (await ejecutar("devolucion", body, "Devolución registrada: el bien pasa a «Bienes devueltos»")) onOpenChange(false); }}
      form={<>
        <SubirPdfOt creditoId={creditoId} tipo={DOC_ACTA_ENTREGA} etiqueta="Acta de entrega-recepción firmada" doc={d.doc}
          onDoc={(x) => set("doc", x)} testid="ot-devolucion-acta" />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <div><Label className="mb-1 block text-xs">Fecha de entrega</Label>
            <Input data-testid="ot-devolucion-fecha" type="date" max={hoy()} value={d.fecha_entrega || ""} onChange={(e) => set("fecha_entrega", e.target.value)} /></div>
          <div><Label className="mb-1 block text-xs">Recibe por la arrendadora</Label>
            <Input data-testid="ot-devolucion-recibe" value={d.recibido_por || ""} onChange={(e) => set("recibido_por", e.target.value)} /></div>
        </div>
        <div><Label className="mb-1 block text-xs">Estado físico del bien</Label>
          <Textarea data-testid="ot-devolucion-estado" rows={2} value={d.estado_bien || ""} onChange={(e) => set("estado_bien", e.target.value)} /></div>
      </>}
      resumen={<>
        <FilasResumen testid="ot-devolucion-resumen" filas={[["Bien", bien], ["Número de serie", b.numero_serie],
          ["Residual que se cancela", mxn(ot.residual), true], ["Fecha de entrega", fdate(d.fecha_entrega)],
          ["Recibe", d.recibido_por], ["Estado del bien", d.estado_bien || "—"], ["Acta", d.doc?.nombre_archivo]]} />
        <p className="text-xs text-slate-600">El residual queda «Cancelada por devolución», el crédito <b>Liquidado</b> y el bien aparece en
          «Bienes devueltos» de Cartera.</p>
      </>} />
  );
}
